var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"pdfMain",staticClass:"pdf-main"},[_c('div',{attrs:{"id":"pdf-container"}}),_c('div',{ref:"pdfContainer"})])}
var staticRenderFns = []

export { render, staticRenderFns }